const getters = {
  token: state => state.user.token,
  baseRoute: state => {
    // 如果没有权限路由，返回所有路由
    if (!state.permission.routes || state.permission.routes.length === 0) {
      return require('@/router').asyncRoutes;
    }
    return state.permission.routes;
  },
  userInfo: state => state.user.accountInfo
};
export default getters;